import SecondInputForm from "../../components/PageComponents/SecondInputForm/SecondInputForm";

const SecondInputPage = ({ documentId }) => {
  return (
    <div className="SecondInputPage">
      <SecondInputForm docId={documentId} />
    </div>
  );
};

export default SecondInputPage;
 